import AppDownloadBanner from './AppDownloadBanner'

export default AppDownloadBanner
// eslint-disable-next-line import/export
export * from './AppDownloadBanner'
